import * as React from "react";

import { useLocalize } from "@/modules/shared/context/localize/LocalizeContext";

import { PolishMinimumWageConfigurationModel } from "@/app/models/configuration/minimumWage/polishMinimumWageConfigurationModel"

import { FieldsetSection } from "../components/FieldsetSection";
import { RowCheckbox } from "../components/RowCheckbox";

const defaultFields: MinimumWagePolishOptionsSectionFieldName[] = [
    "includeAdditionForOvertimeFromContract",
    "includeAdditionForWorkOnHolidaysFromContract",
    "includeAdditionForDutyFromContract",
    "includeAdditionForNightTimeWorkFromContract",
    "includeBounsFromContract",
    "includeEuWorkAddition",
]

export type MinimumWagePolishOptionsSectionFieldName =
    | "includeAdditionForOvertimeFromContract"
    | "includeAdditionForWorkOnHolidaysFromContract"
    | "includeAdditionForDutyFromContract"
    | "includeAdditionForNightTimeWorkFromContract"
    | "includeBounsFromContract"
    | "includeEuWorkAddition"

type Props = {
    className?: string
    loading?: boolean
    state: PolishMinimumWageConfigurationModel
    setState: React.Dispatch<React.SetStateAction<PolishMinimumWageConfigurationModel>>
}

export const PolishOptionsSection = ({
    className,
    loading,
    state,
    setState,
}: Props) => {
    const { t } = useLocalize()

    const updateValue = React.useCallback((name: string, value: any) => {
        setState((s) => ({
            ...s,
            configuration: {
                ...s.configuration,
                [name]: value,
            },
        }))
    }, [setState])

    if (loading) {
        return <p>Loading...</p>
    }

    const basicConfiguration = state.configuration

    const readOnly = false

    return (
        <div className={className}>
            <FieldsetSection title={t('configuration.minimumWages.options')}>
                {/* includeAdditionForOvertimeFromContract */}
                <RowCheckbox
                    label={t('configuration.minimumWages.dontReduceBelowMinimalRate')}
                    id="dontReduceBelowMinimalRate"
                    name="dontReduceBelowMinimalRate"
                    checked={basicConfiguration?.dontReduceBelowMinimalRate}
                    readOnly={readOnly}
                    setValue={(value) => updateValue('dontReduceBelowMinimalRate', value)}
                />
            </FieldsetSection>
        </div>
    )
}
